import "../styles/App.css";
import "../styles/pages/Home.css";

import Carousel from "../components/ImageCarousel";

const loadImages = () => {
  const images = [
    "/images/office1.png",
    "/images/office2.png",
    "/images/office3.png",
    "/images/office4.png",
    "/images/office5.png",
    "/images/office6.png",
  ]

  return (images.map((img, idx) => {
    return (
      <img
        key={`slide-${idx}`}
        className="imageSlide"
        src={img}
        alt={`slide ${idx}`}
      />
    )
  }))
}

function Home() {
  return (
    <div id="home" className="section">
      <div className="homeWrapper">
        '<img alt='logo' src={`/images/logo.png`} className="homeLogo" />
        <Carousel items={loadImages()}/>
      </div>
    </div>
  );
}

export default Home;

